module.exports = __webpack_public_path__ + "static/media/dawulunshan1.d3e9881b.jpeg";